import { abbreviateNumber, theme } from '@hhgtech/hhg-components'
import { Text } from '@hhgtech/hhg-components/mantine'
import { useIntl } from 'react-intl'

import { StyledDetailStatistic } from './index.styled'

type DetailStatisticProps = {
  postsCount: number
  membersCount: number
  size?: 'default' | 'small'
}
export const DetailStatistic = ({
  postsCount,
  membersCount,
  size: sizeProps,
}: DetailStatisticProps) => {
  const { formatMessage: f } = useIntl()
  const size = sizeProps === 'default' ? 'p4' : 'p5'

  return (
    <StyledDetailStatistic>
      {postsCount >= 1000 && (
        <Text as="span" size={size} color={theme.colors.gray600}>
          <Text
            as="span"
            size={size}
            weight="semiBold"
            color={theme.colors.gray700}
          >
            {abbreviateNumber(postsCount)}
          </Text>{' '}
          {f({
            id: 'embedCommunity.card.posts',
            defaultMessage: 'Posts',
          })}
        </Text>
      )}
      {membersCount >= 1000 && (
        <Text
          as="span"
          className="number"
          size={size}
          color={theme.colors.gray600}
        >
          <Text
            as="span"
            size={size}
            weight="semiBold"
            color={theme.colors.gray700}
          >
            {abbreviateNumber(membersCount)}
          </Text>{' '}
          {f({
            id: 'embedCommunity.card.members',
            defaultMessage: 'Members',
          })}
        </Text>
      )}
    </StyledDetailStatistic>
  )
}
